import { WACloudApiSettings } from 'src/app/core/alcmeon-context/models';

export function facebookSDKInitializer({ appId, graphApiVersion }: WACloudApiSettings) {
  return new Promise(resolve => {
    // wait for facebook sdk to initialize before starting the angular app
    window.fbAsyncInit = function () {
      // JavaScript SDK configuration and setup
      FB.init({
        appId, // Facebook App ID
        cookie: true, // enable cookies
        xfbml: true, // parse social plugins on this page
        version: graphApiVersion, // 'v19.0', //Graph API version
      });
    };

    // Load the JavaScript SDK asynchronously
    (function (d, s, id) {
      const fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {
        return;
      }
      const js: any = d.createElement(s);
      js.id = id;
      js.src = 'https://connect.facebook.net/en_US/sdk.js';
      fjs.parentNode.insertBefore(js, fjs);
    })(document, 'script', 'facebook-jssdk');

    resolve(1);
  });
}
